import { AuthenticationModule } from '@aize/authentication';
import { DSDialogModule } from '@aize/shuffle-ds';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { routes } from '@app/app.routes';
import { DateTimeInterceptor } from '@app/core/shared/interceptors/date-time.interceptor';
import { UserContextKind } from '@app/core/shared/models/context-kind';
import { FeatureFlagService } from '@app/core/shared/services/feature-flag/feature-flag.service';
import { environment } from '@environment/environment';
import { ApplicationAuthService } from '@services/application-auth.service';
import { KeycloakAuthService } from '@services/keycloak-auth.service';
import { KeycloakAngularModule } from 'keycloak-angular';
import { BoostrapAuthConfigHelper } from '../../shared/BoostrapAuthConfigHelper';
import { provideTelemetry } from '@elementz/telemetry';

export const SHARED_PROVIDERS = [
  provideRouter(routes),
  provideHttpClient(),
  provideAnimations(),
  {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [FeatureFlagService],
    useFactory: (ff: FeatureFlagService) => {
      return () => {
        const context: UserContextKind = {
          kind: 'user',
          key: 'anonymous',
          anonymous: true,
          tenantId: environment.auth0?.tenantId
        };
        return ff.initialize(context);
      };
    }
  },
  importProvidersFrom(
    KeycloakAngularModule,
    AuthenticationModule.forRoot(
      environment.offline
        ? BoostrapAuthConfigHelper.getOfflineAuthOptions()
        : BoostrapAuthConfigHelper.getTwinAuthOptions()
    ),
    DSDialogModule
  ),
  {
    provide: ApplicationAuthService,
    useClass: environment.offline ? KeycloakAuthService : ApplicationAuthService
  },
  { provide: HTTP_INTERCEPTORS, useClass: DateTimeInterceptor, multi: true },
  BoostrapAuthConfigHelper.getKeycloakInitializerProvider(),
  { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
  { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } },
  { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
  {
    provide: MAT_DIALOG_DEFAULT_OPTIONS,
    useValue: { ...new MatDialogConfig(), disableClose: true, autoFocus: null }
  },
  BoostrapAuthConfigHelper.getApolloProvider(),
  provideTelemetry({
    connectionString: environment.appinsights?.connectionString,
    appName: 'core-app'
  })
];
